/* eslint-disable react/no-children-prop */
import React from "react";
import { Wrapper } from "./styled";

const Filters = ({ children }) => {
  return <Wrapper children={children} />;
};

export default Filters;
